import { render, staticRenderFns } from "./CrudDeploy.vue?vue&type=template&id=20299029&scoped=true"
import script from "./CrudDeploy.vue?vue&type=script&lang=js"
export * from "./CrudDeploy.vue?vue&type=script&lang=js"
import style0 from "./CrudDeploy.vue?vue&type=style&index=0&id=20299029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20299029",
  null
  
)

export default component.exports